<template>
  <div class="productservice ">
    <div class="productservice_header ">
      <div class="centre">
        <h3 style="margin-left: 40px;">域贝一体化平台</h3>
        <p class="productservice_header_center" style="margin-left: 40px;">
          信息化数字化底座系统，解决应用孤岛问题，让应用互联互通，形成数据合力。
        </p>
        <div class="button" style="margin-left: 40px;" @click="openDialog">联系我们</div>
        <div class="img_box">
          <img class="seal_img" src="../../assets/images/一体化/组43.png" alt="">
          <img class="bottom_shink" src="../../assets/images/一体化/组33.png" alt=""/>
          <img class="shink_1" src="../../assets/images/一体化/组35.png" alt="">
          <img class="shink_2" src="../../assets/images/一体化/组42.png" alt="">
          <img class="shink_3" src="../../assets/images/一体化/组41.png" alt="">
          <img class="shink_4" src="../../assets/images/一体化/组40.png" alt="">
          <img class="Pane_1" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_2" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_3" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_4" src="../../assets/images/电子证书/长方块.png" alt="">
        </div>
        <div class="centre heder-bottom">
          <ul>
            <li>
              <div class="main-img">
                <img style="height:44px;margin-top: 5px;" src="../../assets/images/一体化/一体化动效/组23.png" alt="">
                <img class="img_center" style="top: 32px;left: 95px;" src="../../assets/images/一体化/一体化动效/椭圆932.png" alt="">
              </div>
              <p>统一认证</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:48px;margin-top: 5px;" src="../../assets/images/一体化/一体化动效/组30.png" alt="">
                <img class="img_center" style="top: 27px;left: 360px;" src="../../assets/images/一体化/一体化动效/矩形935拷贝3.png" alt="">
              </div>
              <p>统一管理</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:56px;margin-top: 2px;" src="../../assets/images/一体化/一体化动效/组26.png" alt="">
                <img class="img_center_1" src="../../assets/images/一体化/一体化动效/组25.png" alt="">
              </div>
              <p>数据标准</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:46px;margin-top: 5px;" src="../../assets/images/一体化/一体化动效/矩形954.png" alt="">
                <img class="img_center" style="top: 36px;left: 824px;" src="../../assets/images/一体化/一体化动效/组28.png" alt="">
              </div>
              <p>应用互联</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:48px;margin-top: 5px;" src="../../assets/images/一体化/一体化动效/组31.png" alt="">
                <img class="img_center_2" src="../../assets/images/一体化/一体化动效/矩形963拷贝3.png" alt="">
              </div>
              <p>通用服务</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main-1">
      <div class="centre">
        <p>平台架构</p>
      </div>
      <img class="main-1_right" src="../../assets/images/一体化/拓扑图.png" alt="">
    </div>
    <div class="main-2">
      <div class="centre">
        <p>五个一体化</p>
        <ul>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/一体化/账号一体化.png" alt="">
            </div>
            <p>账号一体化</p>
            <div class="text_box">
              <p>账号一体化</p>
              <span class="bottom_text">统一身份认证，实现用户、组织、角色、权限统一化管理</span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/一体化/管理一体化.png" alt="">
            </div>
            <p>管理一体化</p>
            <div class="text_box">
              <p>管理一体化</p>
              <span class="bottom_text">基于身份的管理体系，实现数据管理、数据访问、应用访问等灵活配置</span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/一体化/应用一体化.png" alt="">
            </div>
            <p>应用一体化</p>
            <div class="text_box">
              <p>应用一体化</p>
              <span class="bottom_text">开放式应用接入模式，实现三方应用快速对接互联互通</span>
            </div>
          </li>
          <li style="margin-right: 0px;">
            <div class="main2-img">
              <img src="../../assets/images/一体化/数据一体化.png" alt="">
            </div>
            <p>数据一体化</p>
            <div class="text_box">
              <p>数据一体化</p>
              <span class="bottom_text">开放式标准数据接口，实现全域基础数据标准化统一化</span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/一体化/服务一体化.png" alt="">
            </div>
            <p>服务一体化</p>
            <div class="text_box">
              <p>服务一体化</p>
              <span class="bottom_text">开放式功能模块组件，实现消息、日志、文档、视频等通用服务</span>
            </div>
          </li>
          
        </ul>
      </div>
    </div>
    <div v-show="dialogVisible" class="callUs_dialog">
      <img class="close" src="../../assets/images/电子证书/close.png" alt="" @click="closeDialog" />
      <!-- <div class="dialog_left">
        <div class="center_box">
            <p style="font-size: 20px;">联系我们</p>
            <p style="font-size: 14px;font-weight: 500;margin-top: 15px;">完善信息后我们会第一时间跟您联系</p>
            <div class="line"></div>
            <span>您的称呼：</span>
            <el-input v-model="formLabelAlign.name"></el-input>
            <span>手机号码：</span>
            <el-input v-model="formLabelAlign.tel"></el-input>
        </div>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div> -->
      <div class="dialog_right">
        <p>方案咨询</p>
        <img class="erw" src="../../assets/images/电子证书/ewm.png" alt=""/>
        <div class="phone_box">
          <img class="phone" src="../../assets/images/电子证书/phone.png" alt=""/>
          <span>13506670580</span>
        </div>
      </div>
    </div>
    <div v-show="dialogVisible" class="backdrop"></div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      formLabelAlign: {
        name: '',
        tel: ''
      },
      defferScroll: function (event) {
        event.preventDefault()
      }
    };
  },
  mounted(){
    document.addEventListener('mouseup',(e)=>{
    var button=document.querySelector('.callUs_dialog') //选择返回的第一个出现的元素
    if(button){
        if(!button.contains(e.target)){ //判断某个元素不是目标元素的子元素 即目标元素以外的区域
          this.dialogVisible=false
          this.move()
        }
      }
    })
  },
  methods: {
    onSubmit() {
      this.dialogVisible = false
    },
    openDialog() {
      this.dialogVisible = true
      document.documentElement.scrollTop = 0
      this.stop()
    },
    closeDialog() {
      this.dialogVisible = false
      this.move()
    },
    stop(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);
    },
    move(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflowY='';
      document.body.style.overflowX='hidden'
      //出现滚动条
      document.removeEventListener("touchmove",mo,false);
    }
  }
};
</script>

<style lang="less" scoped>

.centre {
  width: 1200px;
  margin: 0 auto;
}
.productservice_header {
  height: 670px;
  width: 100%;
  background-image: url('../../assets/images/电子证书/首页图.png');
  padding-top: 200px;
}
.button {
  position: relative;
  width: 131px;
  height: 48px;
  background: linear-gradient(to right, #3186fd , #63a4ff);
  border-radius: 5px;
  // border: 1px solid rgb(51,134,254);
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 100;
  cursor: pointer;
  &:hover {
    background: linear-gradient(to right, #2170de , #4f98fe);
  }
}
.img_box {
  .seal_img {
    position: absolute;
    // width: 747px;
    height: 460px;
    top: 140px;
    left: 43%;
    z-index: 10;
  }
  .bottom_shink {
    position: absolute;
    top: 205px;
    left: 36%;
    z-index: 1;
    opacity: 0;
    animation: shink 3s infinite;
  }
  .shink_1 {
    position: absolute;
    top: 195px;
    left: 55%;
    z-index: 11;
    animation: height1 3.5s infinite ease-in-out;
  }
  .shink_2 {
    position: absolute;
    top: 245px;
    left: 68%;
    z-index: 11;
    animation: height2 3.2s infinite linear;
  }
  .shink_3 {
    position: absolute;
    top: 355px;
    left: 67.6%;
    z-index: 11;
    animation: height3 3.5s infinite;
  }
  .shink_4 {
    position: absolute;
    top: 367px;
    left: 48.8%;
    z-index: 11;
    animation: height4 3.2s infinite;
  }
  .Pane_1 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 290px;
    left: 1%;
    z-index: 1;
    animation: heightchange1 4s infinite;
  }
  .Pane_2 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 160px;
    left: 21%;
    z-index: 1;
    animation: heightchange 4s infinite;
  }
  .Pane_3 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 150px;
    left: 35.1%;
    z-index: 1;
    animation: heightchange2 4.5s infinite;
  }
  .Pane_4 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 90px;
    left: 45%;
    z-index: 1;
    animation: heightchange3 3.8s infinite;
  }
}
@keyframes height1 {
  0% {
    top: 195px;
  }
  50% {
    top: 210px;
  }
  100% {
    top: 195px;
  }
}
@keyframes height2 {
  0% {
    top: 245px;
  }
  50% {
    top: 260px;
  }
  100% {
    top: 245px;
  }
}
@keyframes height3 {
  0% {
    top: 355px;
  }
  50% {
    top: 340px;
  }
  100% {
    top: 355px;
  }
}
@keyframes height4 {
  0% {
    top: 367px;
  }
  50% {
    top: 378px;
  }
  100% {
    top: 367px;
  }
}
@keyframes shink {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@keyframes heightchange {
  0% {
    top: 160px;
    height: 250px;
  }
  50% {
    top: 130px;
    height: 311px;
  }
  100% {
    top: 160px;
    height: 250px;
  }
}
@keyframes heightchange1 {
  0% {
    top: 290px;
    height: 250px;
  }
  50% {
    top: 320px;
    height: 311px;
  }
  100% {
    top: 290px;
    height: 250px;
  }
}
@keyframes heightchange2 {
  0% {
    top: 200px;
    height: 250px;
  }
  50% {
    top: 170px;
    height: 311px;
  }
  100% {
    top: 200px;
    height: 250px;
  }
}
@keyframes heightchange3 {
  0% {
    top: 140px;
    height: 250px;
  }
  50% {
    top: 110px;
    height: 311px;
  }
  100% {
    top: 140px;
    height: 250px;
  }
}
.productservice_header h3 {
  position: relative;
  font-size: 40px;
  font-weight: 500;
  color: #000;
  margin-bottom: 38px;
  z-index: 100;
}
.productservice_header_center {
  position: relative;
  width: 375px;
  font-size: 14px;
  letter-spacing: 2px;
  margin-bottom: 50px;
  line-height: 25px;
  z-index: 100;
}
.productservice_header button {
  width: 131px;
  height: 48px;
  font-size: 16px !important;
  background-color: linear-gradient(to right, rgb(54,131,253) , rgb(97,163,255));
  font-size: 16px;
  &:hover {
    background-color: #2170de;
  }
}
.productservice_header button span {
  font-size: 16px;
}
// 数据
.heder-bottom {
  position: absolute;
  transform: translateY(164px);
  height: 140px;
  background-color: #fff;
  padding: 24px 0;
  box-shadow:0 2px 27px 6px rgba(0, 0, 0, .22);
  border-radius: 4px;
  z-index: 999;
}
.heder-bottom ul li {
  float: left;
  display: block;
  width: 20%;
  text-align: center;
  font-size: 16px;
  &:hover {
    .main-img .img_center {
      transform: rotate(360deg);
    }
    p {
      color: #3186fd;
    }
    .img_center_1{
        transform: scale(1.5);
    }
    .img_center_2{
        transform: translate(5px,-5px);
    }
  }
}
.heder-bottom ul li .main-img {
  display: inline-block;
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  .img_center{
    position: absolute;
    top: -40px;
    transition: 1s;
    z-index: -1;
  }
  .img_center_1{
    position: absolute;
    top: 45px;
    left: 588px;
    transition: .5s;
    z-index: -1;
  }
  .img_center_2{
    position: absolute;
    top: 29px;
    left: 1081px;
    transition: .5s;
    z-index: -1;
  }
}
.main-1 {
  // position: absolute;
  text-align: center;
  width: 100%;
  height: 890px;
  // background-color: rgb(231, 187, 187);
  .arrow {
    position: relative;
    top: -250px;
  }
  .main-1_right{
    transition: 1s;
    &:hover {
      transform: scale(1.2);
    }
  }
}
.main-1 .centre p {
  // margin-top: 148px;
  padding-top: 148px;
  font-size: 30px;
  color: #23405a;
  margin-bottom: 60px;
}
.main-1 .centre img {
  margin-bottom: 60px;
  height: 980px;
}
.main-2 {
  width: 100%;
  height: 500px;
  padding-top: 92px;
  text-align: center;
}
.main-2 .centre p {
  font-size: 30px;
  color: #23405a;
}
.main-2 ul {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
}
.main-2 ul li {
  position: relative;
  top: 0px;
  list-style: none;
  float: left;
  width: 224px;
  height: 242px;
//   margin-right: 20px;
//   margin-bottom: 20px;
  box-shadow:2px 5px 7px 2px rgba(0, 0, 0, .05);
  cursor: pointer;
  transition: .5s;
  overflow: hidden;
  .text_box {
    position: relative;
    top: 32px;
    width: 224px;
    height: 242px;
    background-color: #ffffff;
    border-top: rgb(49,134,253) 10px solid;
    text-align: center;
    transition: 1s;
    z-index: 10;
    p {
        display: inline-block;
        margin-top: 46px;
        font-size: 18px;
        color: #23450a;
    }
    .bottom_text {
      display: inline-block;
      width: 153px;
      margin-top: 23px;
      line-height: 22px;
      color: #475d73;
      font-size: 14px;
      text-align: justify;
    }
  }
}
.main-2 .centre ul li:hover {
  top: -5px;
  box-shadow:2px 5px 7px 1px rgba(0, 0, 0, .2);
  p {
    color: #3186fd;
  }
  .text_box{
    p {
      color: #000;
    }
    top: -210px;
  }
}
.main2-img {
  width: 159px;
  height: 127px;
  margin: 50px 0 0 36px;
}
.main-2 .centre ul li p {
  margin-top: 16px;
  font-size: 16px;
  color: #23405a;
}
.callUs_dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 300px;
  height: 330px;
  border-radius: 5px;
  z-index: 100000;
  background-color: rgb(243, 150, 150);
  .close {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  .dialog_left {
    width: 50%;
    height: 100%;
    float: left;
    background-color: white;
    text-align: center;
    .center_box {
      position: absolute;
      top: 37px;
      left: 33px;
      width: 230px;
      height: 250px;
      display: flex;
      flex-direction: column;
      text-align: left;
      color: black;
      span,.el-input {
        margin-top: 15px;
        font-size: 16px;
      }
    }
    .el-button {
      width: 100px;
      position: relative;
      top: 285px;
    }
    .line {
        height: 5px;
        width: 30px;
        margin-top: 15px;
        border-radius: 5px;
        background-color: rgb(246,65,44);
      }
  }
  .dialog_right {
    width: 100%;
    height: 100%;
    background-color: rgb(49,134,253);
    float: right;
    span {
      font-size: 16px;
    }
    p {
      display: inline-block;
      font-size: 20px;
      color: white;
      font-weight: 100;
      margin-top: 40px;
      margin-left: 25px;
    }
    .erw{
      position: absolute;
      width: 100px;
      height: 100px;
      top: 33%;
    }
    .phone_box {
      position: relative;
      width: 130px;
      height: 20px;
      top: 180px;
      left: 90px;
      display: flex;
      color: white;
      .phone {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.backdrop{
  width:100%;
  height:100%;
  visibility: visible;
  opacity: 1;
  position:fixed;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background: rgba(8, 7, 7, 0.6);
  z-index: 9999;
  // transition: all .2s ease;
  // backdrop-filter: saturate(180%) blur(1px);
}
@media (max-width: 1300px) { 
  .img_box {
    .seal_img {
      position: absolute;
      // width: 747px;
      height: 460px;
      top: 140px;
      left: 40%;
      z-index: 10;
    }
    .bottom_shink {
      position: absolute;
      top: 205px;
      left: 36%;
      z-index: 1;
      opacity: 0;
      animation: shink 3s infinite;
    }
    .shink_1 {
      position: absolute;
      top: 195px;
      left: 58%;
      z-index: 11;
      animation: height1 3.5s infinite ease-in-out;
    }
    .shink_2 {
      position: absolute;
      top: 245px;
      left: 77%;
      z-index: 11;
      animation: height2 3.2s infinite linear;
    }
    .shink_3 {
      position: absolute;
      top: 355px;
      left: 76%;
      z-index: 11;
      animation: height3 3.5s infinite;
    }
    .shink_4 {
      position: absolute;
      top: 367px;
      left: 48%;
      z-index: 11;
      animation: height4 3.2s infinite;
    }
  }
}
</style>
